import React from 'react';
import {
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonPage
} from '@ionic/react';

interface CenteredPageContentProps {
    children: React.ReactNode;
    maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
    contentClassName?: string;
}

const sizeMap = {
    sm: { md: '6', lg: '4', xl: '3' },
    md: { md: '8', lg: '6', xl: '4' },
    lg: { md: '10', lg: '8', xl: '6' },
    xl: { md: '12', lg: '10', xl: '8' }
};

export const CenteredPageContent: React.FC<CenteredPageContentProps> = ({
    children,
    maxWidth = 'md',
    className = '',
    contentClassName = ''
}) => {
    const sizes = sizeMap[maxWidth];
    
    return (
        <IonPage className={className}>
            <IonContent className={`ion-padding ${contentClassName}`}>
                <IonGrid fixed>
                    <IonRow className="ion-justify-content-center">
                        <IonCol
                            size="12"
                            sizeMd={sizes.md}
                            sizeLg={sizes.lg}
                            sizeXl={sizes.xl}
                        >
                            {children}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
}; 